import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import RaddissonSelection from "../Selection2/radissonSelection";
import RadissonShow from "./commercialimagesshow/RadissonShow";
import UnodcSelection from "../Selection2/unodcSelection";
import RiyadhSelection from "../Selection2/RiyadhSelection";
import SadkoSelection from "../Selection2/SadkoSelection";
import RomattemSelection from "../Selection2/RomattemSelection";
import RomatemShow from "./commercialimagesshow/RomatemShow";

export default function RomattemComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/10-RomatemMoveHotel/2.png"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5"> Romatem Move Hotel</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: Assisting Zoom TPU in developing
                  architectural drawings
                </span>
                <span>project duration: 3 Months</span>
                <span>year of completion: 2024</span>
                <span>project location: Uskudar, Istanbul-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
           src="../../Images/CommercialImages/10-RomatemMoveHotel/7.png"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                src="../../Images/CommercialImages/10-RomatemMoveHotel/1.png"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Accessibility,
                <br />
                Sustainability,
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Comfort,
                <br />
                Care,
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Innovation,
                <br />
                Harmony.
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              "Designed with sustainability and accessibility at its core, this
              four-star hotel in Istanbul provides an inclusive, user-friendly
              environment for all guests, including those with special needs,
              ensuring a seamless and comfortable experience from entry to exit
              while embracing biophilic design principles and sustainable
              practices."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
               src="../../Images/CommercialImages/10-RomatemMoveHotel/1.png"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "550px",
                zoom: "85%",
              }}
            >
              The facility, where physical therapy patients can receive both
              therapy and hotel services, was designed in partnership with Zoom
              TPU in Istanbul.
              <br />
              <br />
              We are proud to announce the completion of the four-star hotel
              project that the Zoom/TPU team has worked on with great
              dedication. This specially designed hotel aims to provide an ideal
              accommodation experience for all guests with special needs.
              <br />
              <br />
              Sustainability and Biophilic Design: Sustainability was among the
              top priorities in the design of this project, and meticulous
              attention was given to this aspect. Additionally, biophilic design
              principles were implemented throughout the facility with the
              necessary adjustments. Our project has crowned its sustainability
              efforts by obtaining the GSTC (Global Sustainable Tourism Council)
              certification.
              <br />
              <br />
              User-Friendly Design: In our hotel, special attention was given to
              ensure that all users, regardless of whether they have special
              needs, use the same entryways and traffic flow from the moment
              they enter. Thus, every detail was designed with utmost care to
              prevent our guests with special needs from being marginalized.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                 src="../../Images/CommercialImages/10-RomatemMoveHotel/5.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <RomattemSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
             src="../../Images/CommercialImages/10-RomatemMoveHotel/8b.png"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                Innovative office design blending functionality with movement
                for an inspiring work environment.
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <RomatemShow/>
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
